<template>
  <modal
    title="Add Manually"
    width="45"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="mt-4">
      <p class="flex items-center">
        <abbr class="mr-3 text-primary-yellow">Choose a date</abbr>
        <el-date-picker class="mt-3" />
      </p>
    </div>

    <div class="">
      <div class="flex flex-wrap justify-between pt-6 w-full">
        <div class="w-5/12 mt-2">
          <label class="w-full">Sales (₦ - Excl. Tax):</label>
          <input class="input-field" />
        </div>
        <div class="w-5/12 mt-2">
          <label class="w-full">Tax (₦):</label>
          <input class="input-field" />
        </div>
        <div class="w-full mt-2">
            <label class="w-full">Sales (₦ - Incl. Tax):</label>
            <input class="input-field w-full bg-gray-100" />
          </div>
      </div>
    

      <div class="flex items-center justify-between mt-8">
        <button>cancel</button>
        <base-button
          title="save"
          @click="createUser"
          :loading="creatingUser"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      disableButton: false,
    };
  },
  methods: {
    createUser() {
      //
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.input-field {
  @apply py-2 px-2 rounded border-2 border-gray-200;
}
.split-sales {
  width: 48%;
}
</style>
